import { render, staticRenderFns } from "./MapaAreaConcessao.vue?vue&type=template&id=6c61ba7a&"
import script from "./MapaAreaConcessao.vue?vue&type=script&lang=js&"
export * from "./MapaAreaConcessao.vue?vue&type=script&lang=js&"
import style0 from "./MapaAreaConcessao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports